import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://leetcode.com/graphql',
  cache: new InMemoryCache()
});

export default client;